import React, { useCallback, useEffect, useState } from "react";
import styles from "../renewal/Renew.module.css";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
// import { useNavigate } from "react-router";
import Menu from "../../components/ui/Menu";
import FixedAgent from "../../utils/api/FixedAgent";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import modalStyle from "../customers/Customers.module.css";
import copy from "copy-to-clipboard";
import pinStyles from "./FixedAgentPins.module.css";

const PIN_PLATFORMS = ["NICON", "AG", "AGP", "FGI", "FGIP", "CEI"];

const PIN_TYPE_SUMMARY = [
  { value: "Commercial", label: "Commercial" },
  { value: "PrivateMotor", label: "Private Motor" },
  { value: "TriCycle", label: "Tri Cycle" },
  { value: "MotorCycle", label: "Motor Cycle" },
  { value: "Truck", label: "Truck" },
];

const buildPinTypeLabel = (pins, type) => {
  const normalizedType = type.toLowerCase();
  const exportCount =
    pins?.filter(
      (product) =>
        product.status === "ACTIVE" &&
        product.type?.toLowerCase() === normalizedType &&
        product.export_option?.toLowerCase() === "yes",
    )?.length || 0;

  const nonExportCount =
    pins?.filter(
      (product) =>
        product.status === "ACTIVE" &&
        product.type?.toLowerCase() === normalizedType &&
        product.export_option?.toLowerCase() === "no",
    )?.length || 0;

  return { exportCount, nonExportCount };
};

const TypeIcon = ({ type }) => {
  if (type === "Commercial" || type === "Truck") {
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 18H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2h4l3 3v7a2 2 0 0 1-2 2h-2"/><path d="M9 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M19 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/></svg>;
  } else if (type === "MotorCycle" || type === "TriCycle") {
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M15 6a3.5 3.5 0 1 0-7 0"/><path d="M12 17.5V14l-3-3 4-3 2 3h2"/></svg>;
  } else {
    // Private Motor / default
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H7.3a2 2 0 0 0-1.6.8L3 11l-5.16.86a1 1 0 0 0-.84.99V16h3"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="17.5" cy="16.5" r="2.5"/></svg>;
  }
};

function FixedAgentPins(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [exportOption, setExportOption] = useState("");
  // const [productData, setProductData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fundAgentModal, setFundAgentModal] = useState(false);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState();
  const [fixedAgentEmail, setFixedAgentEmail] = useState();
  const [pinPlatform, setPinPlatform] = useState("");
  const [exportContent, setExportContent] = useState(null);
  const [type, setType] = useState("");
  const [expandedPlatforms, setExpandedPlatforms] = useState({ [PIN_PLATFORMS[0]]: true });

  const togglePlatform = (platform) => {
    setExpandedPlatforms((prev) => ({ ...prev, [platform]: !prev[platform] }));
  };

  const token = useSelector((state) => state.userData.loginData.token);

  //   const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const sellPinRes = await FixedAgent.sellPin({
        token,
        count: amount,
        fixedagent_email: fixedAgentEmail,
        export_option: exportOption,
        // pin_type: productData.platform,
        type: type,
      });
      setIsLoading(false);
      toast.success(sellPinRes?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      fecthPinsCallback();
      setModalOpen(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const fecthPinsCallback = useCallback(() => {
    const fetchCartHistory = async () => {
      try {
        setIsLoading(true);
        const productsListRes = await FixedAgent.getPinList({
          token,
          status: "ACTIVE",
        });
        const rawData = productsListRes.data?.data;
        const productArray = Array.isArray(rawData)
          ? rawData
          : Array.isArray(rawData?.data)
          ? rawData.data
          : [];
        setProducts(productArray);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchCartHistory();
  }, [token]);

  useEffect(() => {
    fecthPinsCallback();
  }, [fecthPinsCallback]);

  // const getProductData = (data) => {
  //   setProductData(data);
  // };

  const exportPinModalOpen = (data) => {
    setPinPlatform(data);
    setFundAgentModal(true);
  };

  const exportPin = async () => {
    setIsLoading(true);
    try {
      const response = await FixedAgent.newExportPins({
        token,
        count: parseInt(count),
        pinType: pinPlatform,
        type,
      });

      const pinCodes = response.data
        .split("\n")
        .slice(1)
        .map((row) => row.split(",")[1]);
      copy(pinCodes.join("\n"));
      toast.success("Copied to clipboard!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setExportContent(pinCodes.join("\n"));

      // const blob = new Blob([response.data], { type: "text/csv" });
      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `export_${pinPlatform}_${Date.now()}.csv`;
      // a.setAttribute("allow-downloads", "");
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // URL.revokeObjectURL(url);
      toast.success("Pins exported successfully", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setIsLoading(false);

      setCount("");
    } catch (error) {
      setIsLoading(false);

      toast.error(error.response.data.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to export pins", error);
    }
  };

  const share = () => {
    const isMobile = () =>
      /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

    if (isMobile() && navigator.share) {
      navigator
        .share({
          text: exportContent,
        })
        .then(() => {
          setFundAgentModal(false);
          setExportContent(null);

          console.log("Successful share");
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      console.log("Web Share API not supported.");
    }
  };

  return (
    <div>
      <ToastContainer />
      {fundAgentModal && (
        <div
          className={modalStyle.modal_overlay}
          onClick={() => setFundAgentModal(false)}
        >
          <div
            className={modalStyle.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={modalStyle.modal_title}>Export Pin</h1>
            <div>
              <input
                className={modalStyle.modal_input}
                type="num"
                onChange={(e) => setCount(e.target.value)}
                value={count}
                placeholder="How many do you want to export"
              />

              <select
                className={modalStyle.modal_input}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                {PIN_TYPE_SUMMARY.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

              {!exportContent ? (
                <button
                  disabled={isLoading}
                  className={modalStyle.modal_button}
                  onClick={() => exportPin()}
                >
                  {isLoading ? `Loading...` : `Export`}
                </button>
              ) : (
                <button
                  className={modalStyle.modal_button2}
                  onClick={() => share()}
                >
                  {isLoading ? `Loading...` : `Share Now`}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {modalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>
              {/* {productsDetails?.product_name} */}
            </h1>
            {/* <p className={styles.modal_description}>Pin Type </p>
            <select
              className={styles.modal_input}
              value={pinType}
              onChange={(e) => setPinType(e.target.value)}
            >
              <option value="">Select Pin Type</option>
              <option value="IEI">IEI</option>
              <option value="CEI">CEI</option>
            </select> */}
            <p className={styles.modal_description}>Fixed Agent</p>
            <input
              className={styles.modal_input}
              type="text"
              value={fixedAgentEmail}
              onChange={(e) => setFixedAgentEmail(e.target.value)}
              placeholder="Enter Fixed Agent Email"
            />
            <p className={styles.modal_description}>Amount </p>
            <input
              className={styles.modal_input}
              type="num"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
            />
            <p className={styles.modal_description}>Export Option</p>
            <select
              className={styles.modal_input}
              value={exportOption}
              onChange={(e) => setExportOption(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>

            <p className={styles.modal_description}>Type</p>
            <select
              className={styles.modal_input}
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Export Option</option>
              {PIN_TYPE_SUMMARY.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            <button
              className={styles.modal_button}
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Proceed"}
            </button>
          </div>
        </div>
      )}

      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>

      <Navbar title="Pins" setShowMenu={props.setShowMenu} />

      {/* ── Page body with proper top padding to clear the fixed Navbar ── */}
      <div className={pinStyles.pageBody}>
        {isLoading && products.length === 0 ? (
          /* ── Animated skeleton loader matching the pins card layout ── */
          <div className={pinStyles.stack}>
            {[1, 2, 3].map((n) => (
              <div key={n} className={`${pinStyles.card} ${pinStyles.skeletonCard}`}>
                {/* Skeleton card header */}
                <div className={pinStyles.skeletonHeader}>
                  <div className={`${pinStyles.skeletonBox} ${pinStyles.skeletonLogoBox}`} />
                  <div className={pinStyles.skeletonHeaderText}>
                    <div className={`${pinStyles.skeletonBox} ${pinStyles.skeletonLine} ${pinStyles.skeletonLineLg}`} />
                    <div className={`${pinStyles.skeletonBox} ${pinStyles.skeletonLine} ${pinStyles.skeletonLineSm}`} />
                  </div>
                  <div className={`${pinStyles.skeletonBox} ${pinStyles.skeletonBtn}`} />
                </div>
                {/* Skeleton card body grid */}
                <div className={pinStyles.skeletonBody}>
                  {[1, 2, 3].map((c) => (
                    <div key={c} className={`${pinStyles.skeletonBox} ${pinStyles.skeletonTile}`} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <>
            <div className={pinStyles.sectionTitle}>PIN AVAILABILITY BY INSURER</div>

            <div className={pinStyles.stack}>
              {PIN_PLATFORMS.map((platform) => {
                const platformPins = products.filter((p) => p.platform === platform);
                const isExpanded = expandedPlatforms[platform];
                const logoClass = platform.toLowerCase();

                return (
                  <div className={pinStyles.card} key={platform}>
                    <div className={pinStyles.cardHeader} onClick={() => togglePlatform(platform)}>
                      <div className={`${pinStyles.logoBox} ${pinStyles[logoClass] || ''}`}>
                        {platform}
                      </div>
                      <div className={pinStyles.headerContent}>
                        <h3 className={pinStyles.insurerName}>{platform}</h3>
                        <p className={pinStyles.insurerSubtitle}>Active for policies</p>
                      </div>
                      <div className={pinStyles.headerActions}>
                        <button
                          className={pinStyles.exportBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            exportPinModalOpen(platform);
                          }}
                        >
                          Export Pins
                        </button>
                        <div className={`${pinStyles.chevron} ${isExpanded ? pinStyles.expanded : ''}`}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M6 9l6 6 6-6"/>
                          </svg>
                        </div>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className={pinStyles.cardBody}>
                        {PIN_TYPE_SUMMARY.map((typeOption) => {
                          const counts = buildPinTypeLabel(platformPins, typeOption.value);
                          const totalTypeCount = counts.exportCount + counts.nonExportCount;
                          const dotCount = Math.min(totalTypeCount, 4);

                          return (
                            <div className={pinStyles.typeItem} key={typeOption.value}>
                              <div className={pinStyles.typeHeader}>
                                <span className={pinStyles.typeIcon}>
                                  <TypeIcon type={typeOption.value} />
                                </span>
                                <span className={pinStyles.typeName}>{typeOption.label}</span>
                              </div>
                              <div className={pinStyles.typeCount}>{totalTypeCount}</div>
                              <div className={pinStyles.typeDots}>
                                {[...Array(4)].map((_, i) => (
                                  <div key={i} className={`${pinStyles.dot} ${i < dotCount ? pinStyles.active : ''}`} />
                                ))}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

           
          </>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default FixedAgentPins;
